import React from 'react';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { Shape } from 'Custom-Mindmap';
import { SHAPES, TEXT_NODE_TYPES } from '../../Shapes/shapeCatalog';
import { CATEGORIES } from '../../Sidebar/shapeLibrary';
import { Section } from '../controls';
import styles from './sections.module.css';

const ICON_BOX = 22;
const ICON_STROKE = 1.5;
const PLAIN_TEXT = 'text';
const OPTIONS = [...TEXT_NODE_TYPES, ...SHAPES];
// Drawn like the sidebar's icons rather than in the node's fill, which may be white or "no fill".
const { fill: ICON_FILL, stroke: ICON_OUTLINE } = CATEGORIES.basic;

// The shape at its own proportions, fitted into the icon box.
const ShapeIcon = ({ type, width, height }) => {
    const scale = ICON_BOX / Math.max(width, height);
    return (
        <Shape
            type={type}
            width={Math.round(width * scale)}
            height={Math.round(height * scale)}
            color={ICON_FILL}
            outlineColor={ICON_OUTLINE}
            strokeWidth={ICON_STROKE}
            fillOpacity={1}
        />
    );
};

/** Every node type as a grid of icons. */
const ShapeSection = ({ values, change }) => (
    <Section id="shape" icon={<CategoryOutlinedIcon />} title="Shape">
        <div className={styles.shapeGrid} role="radiogroup" aria-label="Shape">
            {OPTIONS.map((option) => {
                const isOn = option.type === values.type;
                return (
                    <button
                        key={option.type}
                        type="button"
                        role="radio"
                        aria-checked={isOn}
                        aria-label={option.label}
                        title={option.label}
                        className={`${styles.shapeOption} ${isOn ? styles.shapeOptionOn : ''}`.trim()}
                        onClick={() => change({ type: option.type })}
                    >
                        {option.type === PLAIN_TEXT
                            ? <span className={styles.textGlyph} aria-hidden="true">T</span>
                            : <ShapeIcon {...option} />}
                    </button>
                );
            })}
        </div>
    </Section>
);

export default ShapeSection;
